import { createContext } from "react";
import moment from 'moment-timezone';

function dateFormat(fmt, date) {
    let ret;
    const opt = {
        "Y+": date.getFullYear().toString(),        // 年
        "m+": (date.getMonth() + 1).toString(),     // 月
        "d+": date.getDate().toString(),            // 日
        "H+": date.getHours().toString(),           // 时
        "M+": date.getMinutes().toString(),         // 分
        "S+": date.getSeconds().toString()          // 秒
        // 有其他格式化字符需求可以继续添加，必须转化成字符串
    };
    for (let k in opt) {
        ret = new RegExp("(" + k + ")").exec(fmt);
        if (ret) {
            fmt = fmt.replace(ret[1], (ret[1].length === 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, "0")))
        };
    };
    return fmt;
}

const tipContext = createContext(null);

const convertToBeijingTime = (date) => {
    const beijingOffset = 8 * 60; // Beijing is UTC+8
    const localOffset = date.getTimezoneOffset();
    const beijingTime = new Date(date.getTime() + (beijingOffset + localOffset) * 6000);
    const pad = (num) => num.toString().padStart(2, '0');
    return `${beijingTime.getFullYear()}-${pad(beijingTime.getMonth() + 1)}-${pad(beijingTime.getDate())} ${pad(beijingTime.getHours())}:${pad(beijingTime.getMinutes())}:${pad(beijingTime.getSeconds())}`;
};

function convertToLocalTime(timeStr, timezone) {
    return moment.tz(timeStr, 'YYYY-MM-DD HH:mm:ss', timezone).local().format('YYYY-MM-DD HH:mm:ss');
}

function convertTime(timeStr, fromTimezone, toTimezone) {
    try {
        return moment.tz(timeStr, 'YYYY-MM-DD HH:mm:ss', fromTimezone).tz(toTimezone).format('YYYY-MM-DD HH:mm:ss');
    } catch(e) {
        return ""
    }
}

function formatHHMMSS(seconds) {
    const hours = Math.floor(seconds / 3600);
    const remainingSecondsAfterHours = seconds % 3600;
    const minutes = Math.floor(remainingSecondsAfterHours / 60);
    const remainingSeconds = remainingSecondsAfterHours % 60;

    const formattedHours = String(hours).padStart(2, '0');
    const formattedMinutes = String(minutes).padStart(2, '0');
    const formattedSeconds = String(Math.floor(remainingSeconds)).padStart(2, '0');

    return `${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
}

function buildDeviceTree(root, rawChildren) {
    const ensureArray = (value) => {
        if (!value) {
            return [];
        }

        if (Array.isArray(value)) {
            return value;
        }

        if (typeof value === 'string') {
            try {
                const parsed = JSON.parse(value);
                return Array.isArray(parsed) ? parsed : [];
            } catch (e) {
                return [];
            }
        }

        return [];
    };

    const getId = (device) => {
        return device?.ID ?? device?.DeviceID ?? device?.SlaveID ?? device?.id ?? null;
    };


    let tree = ensureArray(root.tree);
    const uniqueLinks = [];
    const linkIds = new Set();
    tree.forEach((link) => {
        if (!link || typeof link !== "object") {
            return;
        }
        const master = link.MasterID ?? link.masterId ?? link.masterID ?? "";
        const slave = link.SlaveID ?? link.slaveId ?? link.slaveID ?? "";
        const key = `${master}:${slave}`;
        if (linkIds.has(key)) {
            return;
        }
        linkIds.add(key);
        uniqueLinks.push(link);
    });
    tree = uniqueLinks;

    const rawNodes = ensureArray(rawChildren);
    const mapNodes = new Map();
    rawNodes.forEach((node) => {
        node.IsSlave = 1;
        const id = getId(node);
        if (id) {
            mapNodes.set(id, node);
        }
    });
    const queue = [rawNodes];
    while (queue.length > 0) {
        const qs = queue.shift();
        const rForDeleting = [];
        qs.forEach((node, i) => {
            if (!node) {
                return;
            }
            const rs = [];
            const id = getId(node);
            tree.forEach((t) => {
                if (t.MasterID === id && t.SlaveID !== id) {
                    const n = mapNodes.get(t.SlaveID);
                    if (n) {
                        if (node.ProductID == "caeb7077-29f8-458b-ba2d-859856994164") {// Energy Port
                            n.MasterID = node.ID; //Only burns on the nearest Energy Port
                        }
                        rs.push(n);
                        rForDeleting.push(n);
                    }
                }
            });
            if (rs.length > 0) {
                queue.push(rs);
                node.children = rs;
            }
            if (node.ProductID == "caeb7077-29f8-458b-ba2d-859856994164") {// Energy Port
                node.MasterID = node.ID; //Only burns on Self
            }
        });
        rForDeleting.forEach((n) => {
            const index = qs.indexOf(n);
            if (index > -1) {
                qs.splice(index, 1);
            }
        });
    }

    return rawNodes.length>0 ? rawNodes : undefined;
}

const all = {
    dateFormat: dateFormat,
    tipContext: tipContext,
    convertToBeijingTime: convertToBeijingTime,
    convertToLocalTime: convertToLocalTime,
    convertTime: convertTime,
    formatHHMMSS: formatHHMMSS,
    buildDeviceTree: buildDeviceTree
}

export default all;